<template>
  <div class="dialog container-fluid">
    <a style="color: #333333;font-size: 25px;font-weight: bold">确认订单信息</a>
    <!-- 商品信息 -->
    <div style="margin-top: 20px">
      <h5>商品信息</h5>
      <table class="am-table am-table-bordered sale_table" style="margin-top: 20px">
        <thead>
        <tr>
          <td>课程名称</td>
          <td>金额</td>
          <td>优惠</td>
          <td>优惠后金额</td>
        </tr>
        </thead>
        <tfoot>
        <!-- 代金券 -->
        <!--        <tr style="font-family: PingFangSC-Medium; font-size: 14px;">-->
        <!--          <td colspan="4">优惠券-->
        <!--            <span colspan="4" v-show="!order_content.voucherList.length>0" class="grey">无可用优惠券-->
        <!--              </span>-->
        <!--          </td>-->
        <!--        </tr>-->
        <tr class="wajycontent" v-if="order_content.voucherList.length>0">
          <td class="hide wznocontent">此课程优惠券和余额不可同时使用</td>
          <td colspan="4" class="wzhascontent" style="border-top: none;">
            <div class="stamp stamp01"
                 v-for="(item,index) in order_content.voucherList"
                 @click="chooseThisVoucher(index,item.value, item.id)"
                 :class="{cur: index == using_voucher.index}">
              <div class="par">
                <p>{{ item.name }}</p>
                <sub class="sign">￥</sub><span>{{ item.value }}</span><sub>优惠券</sub>
                <laber name="d1">订单满</laber>
                <laber name="d1">{{ item.minValue }}</laber>
                <laber name="d1">元可用</laber>
              </div>
              <div class="copy">副券<p>{{ item.inValidTime }}</p></div>
              <i></i>
            </div>
          </td>
        </tr>
        <!-- 余额 -->
        <!--        <tr class="hr">-->
        <!--          <td colspan="4" v-if="!order_content.supportBalance" class="grey">余额不可用</td>-->
        <!--          <td colspan="4" v-else>余额-->
        <!--            <span class="price">￥{{ order_content.balance }}</span>-->
        <!--            <span class="right">-->
        <!--                <button class="hide used wzdisable">禁用</button>-->
        <!--                <button id="wzavailable" v-show="order_content.balance>0.01" :class="{used: using_balance.used}"-->
        <!--                        @click="useBalance">{{ using_balance.used ? '已抵用' : '抵用' }}-->
        <!--                </button>-->
        <!--              </span>-->
        <!--          </td>-->
        <!--        </tr>-->
        </tfoot>
        <tbody>
        <tr>
          <td class="title">
            <p>{{ order_content.productName }}</p>
            <p class="small light">订单编号: {{ order_content.orderId }}</p>
          </td>
          <td class="price">￥{{ order_content.productPrice }}</td>
          <td class="grey">-￥{{ using_voucher.value }}</td>
          <td class="price">￥{{ order_content.productPrice - using_voucher.value }}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- 收货人信息 -->
    <div v-if="!!order_content.needAddress">
      <h5>收货人信息</h5>
      <ul class="list_of_address">
        <li class="cur" v-if="order_content.address_info.contactName">
          <p class="hr dwName">收货人：{{ order_content.address_info.contactName }}</p>
          <p class="dwAddress">{{ order_content.address_info.contactAddress }}</p>
          <p class="dwNumber">{{ order_content.address_info.contactNumber }}</p>
          <p class="right" @click="changeAddress">修改></p>
        </li>
        <li class="new" v-else @click="changeAddress"><span></span> 新建地址</li>
      </ul>
    </div>

    <div v-if="course_protocal">
      <h5>提示</h5>
      <div
        style="width: 1216px;background-color: #ffffff;padding: 10px;font-size: 14px;border-radius: 8px;border: 1px #e5e5e5 solid;display: flex;flex-direction: row;align-items: center">
        <a>请先阅读且同意</a>
        <a :href="course_protocal" target="_blank" style="font-weight: bold">课程协议</a>
        <img v-if="!protocal_select" style="margin-left: auto;width: 25px;height: 25px" @click="onProtocalClick(true)"
             src="../../common/images/icon_unselect.png">
        <img v-if="protocal_select" style="margin-left: auto;width: 25px;height: 25px" @click="onProtocalClick(false)"
             src="../../common/images/icon_select.png">
      </div>
    </div>

    <!-- 总价 -->
    <div class="foot">
      <!-- <span class="p">总计：</span><span class="money">￥{{total}}</span> -->
      <button class="alipay" @click="cofirmOrder(2)">支付宝支付</button>
      <button class="wechat" @click="cofirmOrder(1)">微信支付</button>
    </div>

    <!-- 弹出框修改地址蒙层 -->
    <div v-show="changingAddress" class="mask changingAddress" @click.self="cancel_change_address">
      <dl class="form">
        <div class="close" @click="cancel_change_address"><i class="icon-close"></i></div>
        <h2>填写收货地址</h2>
        <dt>收货人</dt>
        <dd>
          <input type="text" name="" v-model="receive.contactName"></dd>
        <br/>
        <dt>电话</dt>
        <dd>
          <input type="text" name="" v-model="receive.contactNumber"></dd>
        <br/>
        <dt>地址</dt>
        <dd>
          <input type="text" name="" v-model="receive.contactAddress"></dd>
        <br/>
        <button @click.stop.prevent="save_change_address">保存</button>
      </dl>
    </div>
    <!-- 确认支付弹出框 -->
    <cashier v-show="cashier.show" :finalfee="cashier.value">
      <span slot="final" class="money">{{ cashier.value }}</span>
      <span slot="orderid">{{ order_content.orderId }}</span>
      <img :src="cashier.weixin" slot="weixin"/>
    </cashier>
  </div>
</template>
<script type="text/javascript">
// js库
import urls from '../../common/js/urls.js'
// 组件
import Cashier from './Cashier'

export default {
  name: "order",
  components: {
    Cashier
  },
  data() {
    return {
      order_content: {
        orderId: '',       //订单编号
        pay_type: [],
        address_info: {},
        productPrice: 0,  //原价
        needAddress: 0,   //需要地址
        voucherList: [],  //优惠券
        productName: "",  //课程名称
        apple_id: "",
        originalprice: "",
        supportBalance: 1,
        payTime: "",
        balance: 0,      //余额
        discountType: 0,
        course_id: '',
      },
      cofirmOrderInfo: {
        userid: '',
        username: '',
        ticketId: '',
        productType: 1,
        platform: 2,
        orderId: '',
        discountMethods: '',
      },
      changingAddress: false,
      receive: {
        contactAddress: '',  //收货地址
        contactName: '',    //收货人
        contactNumber: '',  //电话
      },
      using_voucher: {    //是否可优惠
        index: -1,
        value: 0,
        id: -1,
      },
      using_balance: {
        used: false,
      },
      // total: 0,
      cashier: {
        show: false,
        value: 0,
        weixin: 'http://image.app.winlesson.com/subjejctInfoFolder/root/wl_19852_83808_49630.png',
      },
      course_protocal: '',
      protocal_select: false,
    }
  },
  computed: {
    user() {
      var user = this.$store.state.user
      this.cofirmOrderInfo.userid = user.user_id
      this.cofirmOrderInfo.username = user.username
      return this.$store.state.user
    },
    discountType() {
      return this.order_content.discountType
    }
  },
  created: function () {
    if (this.$route.query.course_protocal) {
      this.course_protocal = this.$route.query.course_protocal;
    }
    if (this.$route.query.payCode) {
      this.createOrderByCode(this.$route.query.payCode)
    } else {
      this.createOrder(this.$route.query.pId)
    }
  },
  methods: {
    // 生成订单
    createOrder: function (pId, pType) {
      // 未登录处理：
      if (!this.user.user_id || this.user.user_id == '') {
        this.$message.error('您还没有登录！');
        this.$router.push({path: "/login"})
      }
      // 正常流程：
      var _this = this,
        pId = pId || this.$route.query.pId,
        pType = pType || 1
      //--------------------------------- 创建订单：
      this.axios.post(urls.create_order + '?userid=' + this.user.user_id + '&productId=' + pId + '&productType=' + pType + '&username=' + this.user.username + "&from=web").then((response) => {
        if (response.code === 200) {
          return false
        }
        console.log(response);
        for (var key in _this.order_content) {
          _this.order_content[key] = response.data.result[key]
        }
        // 信息初始化
        this.cofirmOrderInfo.orderId = this.order_content.orderId
        // 修改地址专用
        for (var key in this.receive) {
          this.receive[key] = this.order_content.address_info[key]
        }
        // 最终价格初始化
        // this.total = this.order_content.productPrice
      })
    },
    createOrderByCode: function (payCode) {
      // 未登录处理：
      if (!this.user.user_id || this.user.user_id === '') {
        this.$message.error('您还没有登录！');
        this.$router.push({path: "/login"})
      }
      // 正常流程：
      var _this = this
      //--------------------------------- 创建订单：
      this.axios.post(urls.create_order_by_code + '?userid=' + this.user.user_id + '&code=' + payCode + '&username=' + this.user.username).then((response) => {
        if (response.data.code === '200') {
          for (var key in _this.order_content) {
            _this.order_content[key] = response.data.result[key]
          }
          // 信息初始化
          this.cofirmOrderInfo.orderId = this.order_content.orderId
          // 修改地址专用
          for (var key in this.receive) {
            this.receive[key] = this.order_content.address_info[key]
          }
        } else {
          this.$message.error('优惠码错误或已使用！请联系班主任');
          this.$router.back(-1)
        }
        // 最终价格初始化
        // this.total = this.order_content.productPrice
      })
    },
    cancel_change_address: function () {
      this.changingAddress = false
    },
    save_change_address: function () {
      var _this = this
      var temp_url = urls.change_address + '?';
      for (var item in this.receive) {
        temp_url += item + '=' + encodeURI(this.receive[item]) + '&'
      }
      temp_url += 'userid=' + this.cofirmOrderInfo.userid + '&orderId=' + this.cofirmOrderInfo.orderId + '&productId=' + this.$route.query.pId
      // ---------------------------  上传记录
      this.axios.post(temp_url).then((response) => {
        if (response.data.code != 200) {
          this.$message.error('抱歉，保存新地址失败了，请一会儿重试！');
          return false
        }
        _this.changingAddress = false
        // 更新地址显示
        $(".dwName").html(this.receive.contactName);
        $(".dwAddress").html(this.receive.contactNumber);
        $(".dwNumber").html(this.receive.contactAddress);
        //_this.createOrder()
      })
    },
    changeAddress: function () {
      this.changingAddress = true;
    },
    // 选择优惠方式：
    chooseThisVoucher: function (index, value, id) {
      if (this.using_voucher.index == index) {
        this.using_voucher.index = -1
        this.using_voucher.value = 0
        this.using_voucher.id = -1
        $(".wzdisable").addClass('hide');
        $("#wzavailable").removeClass('hide');
      } else {
        if (this.discountType == 0) {//discountType优惠方式组合使用方式：0=互斥；1=可同时使用
          this.using_balance.used = false;
          $(".wzdisable").removeClass('hide');
          $("#wzavailable").addClass('hide');
        }
        this.using_voucher.index = index
        this.using_voucher.value = value
        this.using_voucher.id = id
      }
    },
    useBalance: function () {
      if (!this.using_balance.used) {
        if (this.discountType == 0) {//discountType优惠方式组合使用方式：0=互斥；1=可同时使用
          this.using_voucher.index = -1
          this.using_voucher.value = 0
          this.using_voucher.id = -1
        }
        this.using_balance.used = true
        $(".wznocontent").removeClass('hide');
        $(".wzhascontent").addClass('hide');
      } else {
        this.using_balance.used = false
        $(".wznocontent").addClass('hide');
        $(".wzhascontent").removeClass('hide');
      }
    },
    // 确认支付
    cofirmOrder: function (type) {
      this.save_change_address();
      if (this.order_content.needAddress == 1) {
        if (this.order_content.address_info.contactName == '') {
          this.$message.error('请输入收货人姓名！');
          return false;
        }
        if (this.order_content.address_info.contactAddress == '') {
          this.$message.error('请输入收货人的收货地址！');
          return false;
        }
        if (this.order_content.address_info.contactNumber == '') {
          this.$message.error('请输入收货人电话！');
          return false;
        }
        if (this.course_protocal && !this.protocal_select) {
          this.$message.error('请先阅读协议！');
          return false;
        }
      }
      var _this = this
      // discountMethods: 支持的优惠支付方式："YE"=余额，"DJQ"=代金券，多种方式以","分隔':
      if (!this.discountType) {
        if (this.using_balance.used) {
          this.cofirmOrderInfo.discountMethods = 'YE'
        } else if (this.using_voucher.id != -1) {
          this.cofirmOrderInfo.discountMethods = 'DJQ'
          this.cofirmOrderInfo.ticketId = this.using_voucher.id
        }
      } else if (this.discountType && (this.using_voucher.id != -1) && this.using_balance.used) {
        this.cofirmOrderInfo.discountMethods = 'DJQ,YE'
      }
      // 创建url：
      var temp_url = urls.confirm_order + '?';
      for (var item in this.cofirmOrderInfo) {
        if (item == 'discountMethods' && this.cofirmOrderInfo.discountMethods == '') continue;
        temp_url += item + '=' + this.cofirmOrderInfo[item] + '&'
      }
      temp_url = temp_url.slice(0, -1)
      //----------------------------- 提交订单：
      this.axios.post(temp_url).then((response) => {
        if (response.data.code != 200) return false
        // 做到这里了
        _this.cashier.value = response.data.result.finalFee
        _this.cashier.show = true
        _this.getWeixinCode(_this.cofirmOrderInfo.orderId, type)
      })
    },
    getWeixinCode: function (order_id, type) {
      var _this = this
      if (type === 1) {//微信
        this.axios.get(urls.wxcode + '?order_id=' + order_id).then((response) => {
          // if (response.data.code != 200) return false
          _this.cashier.weixin = response.data.url
        })
      } else {//支付宝
        this.axios.post(urls.alicode + '?order_id=' + order_id + "&good_name=" + _this.order_content.productName).then((response) => {
          // if (response.data.code != 200) return false
          _this.cashier.weixin = response.data.cdn_url
        })
      }
    },
    //---------------------------------微信
    onProtocalClick: function (state) {
      this.protocal_select = state;
    }
  }
}

</script>
<style scoped>

.dialog > * {
  margin-bottom: 20px;
}

.dialog h5 {
  margin-bottom: 10px;
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #333333;
}

.dialog .list_of_address li {
  box-sizing: border-box;
  width: 280px;
  height: 154px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #333;
  padding: 15px;
  display: inline-block;
  vertical-align: top;
  margin-right: 20px;
  position: relative;
  border: 1px solid #ccc;
}

.dialog .list_of_address li h6 {
  position: relative;
  margin-bottom: 17px;
  font-weight: normal;
  padding: 0;
}

.dialog .list_of_address li h6:after {
  bottom: -5px;
}

.dialog .list_of_address li p + p {
  margin-top: 10px;
}

.dialog .list_of_address li p.right {
  text-align: right;
  font-size: 12px;
  color: #999;
  cursor: pointer;
  position: absolute;
  right: 15px;
  bottom: 0;
}

.dialog .list_of_address li.cur {
  border: 1px solid #e5e5e5;
  background-color: #fff;
  border-radius: 8px;
}

.dialog .list_of_address li.new {
  text-align: center;
  font-size: 12px;
  color: #999;
}

.dialog .list_of_address li.new span {
  display: block;
  width: 40px;
  height: 40px;
  margin: 24px auto 10px;
  background-image: url('./images/plus.png');
}

.dialog .sale_table {
  border-color: #e5e5e5;
  background: #f9f9f9;
}

.dialog .sale_table td {
  vertical-align: middle;
  padding-left: 15px;
  padding-right: 15px;
}

.dialog .sale_table thead td,
.dialog .sale_table tbody td:not(.title) {
  text-align: center;
}

.dialog .sale_table tbody,
.dialog .sale_table .voucherlist li {
  background: #fff;
}

.dialog .sale_table tbody > tr:first-child > td {
  border-top: 1px solid #e5e5e5;
}

.dialog .sale_table thead td + td,
.dialog .sale_table tbody td + td {
  width: 150px;
}

.dialog .sale_table tbody td + td {
  border-left: transparent;
}

.dialog .sale_table .voucherlist {
  margin-bottom: 20px;
}

.dialog .sale_table .voucherlist li {
  padding: 10px 23px;
  margin-right: 20px;
  margin-bottom: 10px;
  font-family: PingFangSC-Semibold;
  font-size: 24px;
  color: #666666;
  display: inline-block;
  border: 2px solid #e5e5e5;
}

.dialog .sale_table .voucherlist li.cur {
  border: 2px solid #E37D28;
}

.dialog .sale_table tr.hr td {
  padding: 15px;
  border-top: none;
  clear: both;
  position: relative;
}

.dialog .sale_table tr.hr td .right {
  float: right;
}

.dialog .sale_table tr.hr td:after {
  content: "";
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 2px;
  /*background-image: url("/static/icon/hr_dots_wide.png");*/
  background-repeat: repeat-x;
}

.dialog .sale_table tr.hr button {
  width: 64px;
  height: 26px;
  background: #ffbc42;
  color: #fff;
  border-radius: 8px;
  cursor: pointer;
  font-weight: normal;
  border: none;
}

.dialog .sale_table tr.hr button.used {
  background: #e5e5e5;
  color: #fff;
}

.dialog .sale_table tbody .price {
  font-size: 18px;
}

.dialog .sale_table tbody .title {
  font-size: 18px;
}

.dialog .sale_table tbody .title p:first-child {
  margin-bottom: 5px;
}

.dialog .sale_table tbody tr {
  height: 77px;
}

.dialog .sale_table .price {
  font-family: PingFangSC-Semibold;
  color: #E37D28;
  font-weight: bold;
}

.dialog .sale_table .small {
  font-size: 12px;
}

.dialog .sale_table .grey {
  color: #999;
}

.dialog .sale_table .light {
  color: #ccc;
}

.dialog .foot button.wechat {
  margin-top: 10px;
  float: right;
  background: #09bb07;
  width: 234px;
  height: 50px;
  margin-left: 30px;
  border: none;
  cursor: pointer;
  border-radius: 8px;
  font-size: 18px;
  color: #fff;
}

.dialog .foot button.alipay {
  margin-top: 10px;
  float: right;
  background: #3A76F5;
  width: 234px;
  height: 50px;
  margin-left: 30px;
  border: none;
  cursor: pointer;
  border-radius: 8px;
  font-size: 18px;
  color: #fff;
}

.changingAddress .form {
  width: 550px;
  padding: 40px;
  margin: auto;
  top: 20%;
  left: 0;
  right: 0;
}

.changingAddress .form h2 {
  margin-top: 0;
  margin-bottom: 20px;
}

.changingAddress .form dt,
.changingAddress .form dd {
  display: inline-block;
  height: 36px;
  line-height: 36px;
  margin-bottom: 20px;
}

.changingAddress .form dt {
  width: 58px;
  padding-right: 5px;
}

.changingAddress .form input {
  width: 300px;
  height: 100%;
  padding-left: .5em;
}

.changingAddress .form button {
  width: 160px;
  height: 36px;
  line-height: 36px;
  margin: 10px 157px;
  border-radius: 8px;
  background: #ffbc42;
  color: #fff;
  border: none;
}

.changingAddress .form .close {
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
}

.dialog .sale_table {
  border-color: #e5e5e5;
  background: #f9f9f9;
}

.am-table {
  width: 100%;
  margin-bottom: 1.6rem;
  border-spacing: 0;
  border-collapse: separate;
}

.am-table-bordered {
  border: 1px solid #f2f2f2;
  border-radius: 8px;
}

.dialog .sale_table td {
  vertical-align: middle;
  padding: 10px 15px;
}

.am-table-bordered > thead > tr > td,
.am-table-bordered > thead > tr > th {
  border-left: 1px solid #f2f2f2;
}

.container-fluid {
  margin-top: 30px;
}

/*模态框*/
.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99;
}

.cashier {
  background: #fff;
  position: absolute;
  margin: auto;
  top: 20%;
  left: 0;
  right: 0;
  width: 410px;
  padding: 40px;
  border-radius: 8px;
}

.changingAddress .form {
  width: 480px;
  padding: 40px;
  margin: auto;
  top: 20%;
  left: 0;
  right: 0;
  border-radius: 8px;
}

.changingAddress .form input {
  border-radius: 8px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 1;
  outline: none;
  padding: 0 15px;
}

.changingAddress .form dt {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}

.mask > * {
  background: #fff;
  position: absolute;
}

.list_of_address {
  padding-left: 0;
}

.list_of_address li h6 {
  position: relative;
  margin-bottom: 17px;
  font-weight: normal;
  padding: 0;
  font-size: 14px;
  margin-top: 5px;
  height: 25px;
  line-height: 18px;
  border-bottom: 2px dashed #f2f2f2;
}


/*-----------------------------------优惠券-----------------------------*/

.stamp * {
  padding: 0;
  margin: 0;
  list-style: none;
  font-family: "Microsoft YaHei", 'Source Code Pro', Menlo, Consolas, Monaco, monospace;
}

.stamp {
  width: 315px;
  height: 122px;
  padding: 0 10px;
  margin-bottom: 50px;
  position: relative;
  overflow: hidden;
  float: left;
  margin-right: 10px;
}

.stamp:before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 10px;
  right: 10px;
  z-index: -1;
}

.stamp i {
  position: absolute;
  left: 20%;
  top: 45px;
  height: 190px;
  width: 390px;
  background-color: rgba(255, 255, 255, .15);
  transform: rotate(-30deg);
}

.stamp .par {
  float: left;
  padding: 9px 15px;
  width: 154px;
  border-right: 2px dashed rgba(255, 255, 255, .3);
  text-align: left;
}

.stamp .par p {
  color: #fff;
  font-size: 16px;
  line-height: 21px;
}

.stamp .par span {
  font-size: 34px;
  color: #fff;
  margin-right: 5px;
  line-height: 65px;
}

.stamp .par .sign {
  font-size: 34px;
}

.stamp .par sub {
  position: relative;
  top: -5px;
  color: rgba(255, 255, 255, .8);
}

.stamp laber {
  color: #fff;
  font-size: 12px;
  margin-left: 10px;
}

.stamp .copy {
  display: inline-block;
  padding: 21px 14px;
  width: 100px;
  vertical-align: text-bottom;
  font-size: 24px;
  color: rgb(255, 255, 255);
  text-align: center;
  line-height: initial;
}

.stamp .copy p {
  font-size: 16px;
  margin-top: 15px;
}

.stamp01 {
  background: #F39B00;
  background-position: 9px 3px;
}

.stamp01:before {
  background-color: #F39B00;
}

.cur {
  border: 2px solid #666;
}

.hide {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/OrderPage.vue